import { createContext, useContext, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { SessionUtils } from "../utils/session.utils";

const RespondentContext = createContext(null);

// Minted synchronously (lazy useState initializer, not an effect) so it's
// available on the very first render - no async gate/loading flash needed.
export const RespondentProvider = ({ children }) => {
  const [journeyToken] = useState(() => {
    const existing = SessionUtils.getJourneyToken();
    if (existing) return existing;
    const fresh = uuidv4();
    SessionUtils.setJourneyToken(fresh);
    return fresh;
  });

  const setRespondentToken = (token) => {
    SessionUtils.setRespondentToken(token);
  };

  return <RespondentContext.Provider value={{ journeyToken, setRespondentToken }}>{children}</RespondentContext.Provider>;
};

export const useRespondentContext = () => {
  const ctx = useContext(RespondentContext);
  if (!ctx) {
    throw new Error("useRespondentContext must be used within a RespondentProvider");
  }
  return ctx;
};
